import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import AddPaymentAccountForm from './add-payment-account-form'

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: theme.spacing(2, 3),
    '&:first-child': {
      paddingTop: theme.spacing(2),
    },
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
}))

const AddPaymentAccountDialog = ({ trigger }) => {
  const classes = useStyles()

  return (
    <Dialog trigger={trigger} maxWidth="sm" fullWidth showCloseButton>
      {({ closeDialog }) => {
        return (
          <>
            <DialogTitle>Add Payment Account</DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <AddPaymentAccountForm onCancel={closeDialog} />
            </DialogContent>
          </>
        )
      }}
    </Dialog>
  )
}

export default AddPaymentAccountDialog
